// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#liste_messages_drawer[data-v-e554c250]{max-height:calc(100vh - 50px);overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
